/*
 * Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
 * #  This file forms part of the Trade-DSM application frontend.
 * #  https://github.com/Tooblippe/trade-dsm-frontend
 */

import {isAexiFamily} from '@/components/application-level/js_functions/referrer-utils';

export const config = {
  CEPII_Source:
    isAexiFamily(localStorage.getItem('reload_url'))
      ? 'Source: AEXI, calculated from CEPII (BACI) data'
      : 'Source: Trade Research Advisory, calculated from CEPII (BACI) data',

  trade_blue: 'blue',
  trade_blue2: '#1f3c5f',

  // line graphs
  plot_brown: '#5c3f0b',
  plot_blue: '#162f7a',
  plot_grey: '#777171',
  plot_green: '#00FF00',
  plot_red: '#ee4548',

  //bar graphs
  plot_bar_green: '#78AB46',
  plot_bar_blue: '#162f7a',
  plot_bar_red: '#ee4548',

  plot_line_width: 3,

  // '#ee4548',
  plot_top6_colors: [
    'rgba(5,5,40,1)',
    'rgba(23,23,140,1)',
    'rgba(50,50,197,1)',
    'rgba(98,112,112,1)',
    'rgba(165,165,200,1)',
    'rgba(210,210,210,1)',
    'rgba(6,199,210,1)',
    'rgba(149,55,55,1)',
    'rgb(73,250,13)',
    'rgb(18,243,179)',
    'rgba(144,245,129,0.49)',
    'rgb(232,13,113)',
    'rgb(15,15,243)',
    'rgb(143,143,222)',
    'rgb(204,58,238)',
    'rgb(252,4,4)',
  ],

  mp1c_layouts_lines: {
    height: '300',
    width: '350',
    autosize: true,

    margin: {
      l: 50,
      r: 20,
      b: 10,
      t: 55,
      pad: 2,
    },
  },
  mp1c_layouts_bars: {
    height: '300',
    width: '350',
    autosize: true,

    margin: {
      l: 50,
      r: 20,
      b: 90,
      t: 55,
      pad: 2,
    },
  },
};
